var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "hero d-flex flex-column align-center justify-center pa-4",
    style: {
      height: ("calc(90vh - " + (_vm.$vuetify.application.top) + "px)"),
      'background-position': _vm.$vuetify.breakpoint.lgAndUp ? 'center -10px' : 'center -10px',
      'background-size': _vm.$vuetify.breakpoint.lgAndDown ? 'cover' : ''
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "content-container",
    attrs: {
      "color": "transparent"
    }
  }, [_c('h1', {
    staticClass: "text-h2 hero-title font-weight-black secondary--text mt-2 textStroke",
    staticStyle: {
      "position": "relative",
      "z-index": "2"
    }
  }, [_vm._v(" East Islip Public Library ")]), _c('h2', {
    staticClass: "text-h6 hero-sub-title secondary--text textStrokeSmall mb-4"
  }, [_vm._v(" The Resource Center For Lifelong Learning ")]), _c('search-form', {
    attrs: {
      "inputProps": {
        'hide-details': true
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }